import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, CircularLoader } from '@blade/ui-kit'

// TODO: implement transaction status checking using blockchain explorer API
export const ReferralWithdrawProcessing: React.FC = () => {
  const { t } = useTranslation()

  const isLoading = true
  const handleClose = () => {}

  return (
    <Root>
      <Content>
        <CircularLoaderWrapper>
          <CircularLoader />
        </CircularLoaderWrapper>
        <Title>{t('referral.withdraw.transaction-in-process')}</Title>
        <Message>
          {t('referral.withdraw.transaction-in-process-message')}
        </Message>
      </Content>
      <Actions>
        <Button
          disabled={isLoading}
          variant="solid"
          size="s"
          radius="rounded"
          onClick={handleClose}
        >
          Waiting ...
        </Button>
      </Actions>
    </Root>
  )
}

const Root = styled.div`
  background: var(--background-1);
  padding-block: 20px;
`

const Content = styled.div`
  display: grid;
  gap: 14px;
  justify-content: center;
  justify-items: center;
`

const Title = styled.div`
  color: var(--text-12);
  text-align: center;

  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

const Message = styled.div`
  color: var(--text-9);
  text-align: center;

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

const CircularLoaderWrapper = styled.div`
  border-radius: 16px;
  background: var(--backgroundA-2);

  display: grid;
  width: 60px;
  height: 60px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`

const Actions = styled.div`
  display: grid;

  padding: 30px 12px 0;
`
